export default __webpack_public_path__ + "media/images/preview-a05d8f4c1a1b75ce9a8b43598d393538.png";